































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import RespondecoCategories from '../../../shared/components/respondeco-categories.vue'
import { Injector } from '@/config/dependency-injection'
import { OrganisationsModule } from '@/business/organisation/store/organisations-module'
import { MetaService } from '@/shared/services/meta-service'
import { imageUrl } from '@/shared/utils/images'
import RespondecoEditorLiveView from '@/shared/components/respondeco-editor-live-view.vue'
import { isNotBlank } from '@/shared/utils/is-blank'
import RespondecoPosts from '@/business/post/components/posts.vue'
import { Hooks } from '@/shared/interfaces/hooks'
import OrganisationPosts from '@/business/organisation/components/organisation-posts.vue'

@Component({
  components: {
    OrganisationPosts,
    RespondecoPosts,
    RespondecoEditorLiveView,
    RespondecoCategories,
  },
})
export default class OrganisationAbout extends Vue implements Hooks {
  public imageUrl = imageUrl

  private metaService = Injector.get(MetaService)
  private organisationModule = Injector.get(OrganisationsModule)

  get categoryIsNotEmpty(): boolean {
    return this.organisation.categories.length > 0
  }

  get hasDescription() {
    return isNotBlank(this.organisation.description)
  }

  get hasVision() {
    return isNotBlank(this.organisation.vision)
  }

  get organisation() {
    return this.organisationModule.organisationViewModel.organisation
  }

  get websiteLink(): string | undefined {
    let website = this.organisation?.website

    if (website != null && /https?:/.test(website) === false) {
      website = `http://${website}`
    }

    return website
  }

  get website(): string | undefined {
    const httpRegex = /https?:\/\/(.*)/

    let website = this.organisation?.website

    if (website != null && httpRegex.test(website) === true) {
      const match = httpRegex.exec(website)

      if (match != null && match.length > 1) {
        website = match[1]
      }
    }

    return website
  }

  public created() {
    this.metaService.updateDocumentTitle('organisation.about', {
      name: this.organisation.name,
    })

    this.metaService.updateSeo({
      creator: this.organisation.name,
      description: this.organisation.shortDescription,
      image: this.organisation.image,
    })
  }
}
